import { all, call } from 'redux-saga/effects';
import vdc from './vdc/vdcSagas';

export default function* sagas() {
	yield all([call(vdc)]);
}
